import React from 'react';
import Dropzone from 'react-dropzone';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';

function FieldFileDropzone({onDrop}) {
    const allowedExt = ['pdf', 'jpg', 'jpeg', 'png'];
    const { t } = useTranslation();
    return (
        <Dropzone onDrop={onDrop}>
            {({getRootProps, getInputProps, isDragActive}) => (
                <div {...getRootProps({className: 'file-dropzone'})}>
                    <input {...getInputProps()} />
                    <Typography component={'p'}>{isDragActive ? t('photo_edit.drag_to_place') : t('photo_edit.drag_to_place_additional')}</Typography>
                    <Typography component={'p'}>
                        {t('photo_edit.allowed_file_ext')}: {allowedExt.join(', ')}
                    </Typography>
                </div>
            )}
        </Dropzone>
    );
}

export default FieldFileDropzone;